// FILTERS actions
/* eslint-disable */
import axios from 'axios';
import i18n from '@/i18n';
import types from '../../types';

export default {
  // SEARCH
  [types.TABLE_SEARCH]: async ({ commit }, payload) => {
    let apiString = payload.pageApiURL;
    let queryString;
    let hasMark = false;
    if(payload.hasOwnProperty('filter')) {
      apiString += `?search=${JSON.stringify(payload.filter)}`;
      queryString = `?search=${JSON.stringify(payload.filter)}`;
      hasMark = true;
    }
    if(payload.hasOwnProperty('searchTerm')) {
      if(hasMark) {
        apiString += `&searchTerm=${payload.searchTerm}`;
        queryString += `&searchTerm=${payload.searchTerm}`;
      } else {
        apiString += `?searchTerm=${payload.searchTerm}`;
        queryString += `&searchTerm=${payload.searchTerm}`;
        hasMark = true;
      }
    };
    if(payload.hasOwnProperty('page')){
      if(hasMark) {
        apiString += `&page=${payload.page}`;
      } else {
        apiString += `?page=${payload.page}`;
        hasMark = true;
      }
    };
    if(payload.hasOwnProperty('apiID')){
      if(hasMark) {
        apiString += `&apiID=${payload.apiID}`;
      } else {
        apiString += `?apiID=${payload.apiID}`;
        hasMark = true;
      }
    };
    commit('STORE_ALLSHIPMENT_SEARCH_QUERY', queryString);
    try {
      commit('DATA_NOT_FOUND', false);
      return await axios.get(apiString).then((res) => {
        if (res.data.data.items.length===0){
          commit('DATA_NOT_FOUND', true);
        }else{
          commit('DATA_NOT_FOUND', false);
        }
        return res.data.data;
      });
    } catch (err) {
      console.error(err);
    }
  },
  [types.STORE_SEARCH]: ({ commit }, payload) => {
    commit('STORE_SEARCH', payload);
  },
  [types.CLEAR_SEARCH]: ({ commit }) => {
    commit('CLEAR_SEARCH');
  },
  // SIDEBAR
  [types.OPEN_SIDEBAR]: ({ commit }) => {
    commit('OPEN_SIDEBAR');
  },
  [types.CLOSE_SIDEBAR]: ({ commit }) => {
    commit('CLOSE_SIDEBAR');
  },
  [types.STORE_SIDEBAR_FIELDS]: ({ commit }, payload) => {
    commit('STORE_SIDEBAR_FIELDS', payload);
  },
  [types.CLEAR_SIDEBAR_FIELDS]: ({ commit }) => {
    commit('CLEAR_SIDEBAR_FIELDS');
  },
  // FILTERS
  [types.SET_IS_CUSTOM_FILTER_NAME]: ({ commit }, payload) => {
    commit('SET_IS_CUSTOM_FILTER_NAME', payload);
  },
  [types.SET_IS_NEW_FILTER]: ({ commit }, payload) => {
    commit('SET_IS_NEW_FILTER', payload);
  },
  [types.GET_FILTERS]: async ({ commit }, payload) => {
    try {
      return await axios.get(`filters/${payload}/get`).then((res) => {
        return res.data.data;
      });
    } catch (err) {
      console.error(err);
    }
  },
  [types.SAVE_FILTERS]: async (context, payload) => {
    try {
      await axios.put(`filters/${payload.table_name}/create`, {
        filters_json: payload.filters,
      }).then(() => {
        context.commit('SHOW_NOTIFICATION_BAR', {
          message: i18n.t('filter_added_successfully'),
          type: 'success-window',
          iconName: 'check',
        });
      });
    } catch (err) {
      console.error(err);
    }
  },
  [types.DELETE_FILTER]: async (context, payload) => {
    try {
      return await axios.post(`filters/${payload.tableName}/delete`, {
        filters_json: payload.filters,
      });
    } catch (err) {
      console.error(err);
    }
  },
  [types.STORE_FILTERS_MENU]: ({ commit }, payload) => {
    commit('STORE_FILTERS_MENU', payload);
  },
  [types.CLEAR_FILTERS_MENU]: ({ commit }) => {
    commit('CLEAR_FILTERS_MENU');
  },
  [types.UPDATE_EXISTING_FILTER]: ({ commit }, payload) => {
    commit('OPEN_SIDEBAR');
  },
  [types.STORE_NEW_FILTER]: ({ commit }, payload) => {
    commit('STORE_NEW_FILTER', payload);
  },
  [types.STORE_ACTIVE_FILTER]: ({ commit }, payload) => {
    commit('STORE_ACTIVE_FILTER', payload);
  },
  [types.CLEAR_ACTIVE_FILTER]: ({ commit }) => {
    commit('CLEAR_ACTIVE_FILTER');
  },
  [types.REMOVE_EXISTING_FILTER_PARAM]: ({ commit }, payload) => {
    commit('REMOVE_EXISTING_FILTER_PARAM', payload);
  },
  [types.REMOVE_EXISTING_FILTER_ALL]: ({ commit }) => {
    commit('REMOVE_EXISTING_FILTER_ALL');
  },
  [types.EDIT_EXISTING_FILTER]: ({ commit }, payload) => {
    commit('EDIT_EXISTING_FILTER', payload);
  },
  // # DOVDE JE DOBRO
};
